import type { RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'

/**
 * The calendar-inbox module's routes (WP-07, wp/calendar-inbox §3). Paths and names from the route manifest (D-15).
 * The inbox's paths and names belong to the chat now (src/modules/messages, D-53). Dropped: the demo `/apps/calendar`.
 *
 * - Calendar: Calendar read (D-21; legacy hid only the nav entry — a Staff user without it now gets the not-authorized
 *   page instead of the error toast). A Freelancer may open `/ca|em/calendar` (OPEN-1 (b): no nav entry).
 * - Trash: no resource (legacy nav `always`): the API lists what a Staff user may read and refuses a Freelancer.
 */

const routes: RouteRecordRaw[] = [
  {
    path: '/:software/calendar',
    name: 'calendar',
    component: () => import('./views/CalendarView.vue'),
    meta: {
      software: 'common',
      resource: 'calendar',
      pageTitle: keys.t('common.nav.calendar'),
      breadcrumb: [{ text: keys.t('common.nav.calendar'), active: true }],
    },
  },
  // Calendar phase 3: an applicant's booking page (no session; the token is the key).
  {
    path: '/book/:token([0-9a-f]{40})',
    name: 'calendar-booking',
    component: () => import('./views/BookingView.vue'),
    meta: { layout: 'full', public: true, pageTitle: keys.t('calendarInbox.calendar.booking.title') },
  },
  {
    path: '/:software/trash',
    name: 'trash',
    component: () => import('./views/TrashView.vue'),
    meta: {
      software: 'common',
      pageTitle: keys.t('common.nav.trash'),
      breadcrumb: [{ text: keys.t('common.nav.trash'), to: { name: 'trash' } }],
    },
  },
]

export default routes
